export default __webpack_public_path__ + "static/Desktop-d4516afe4acd0ae1f4ec45c7b11311df.png";